import { createAsyncThunk } from "@reduxjs/toolkit";
import type { OrderException } from "@store/types/OrderExceptions.types";
import { OrderExceptionCode } from "@store/types/OrderExceptions.types";
import { setPaymentTokenToStorage } from "@store/utils/paymentToken";

import { newrelic } from "@jti/fe-clients";
import { getUser, PgsApi } from "@jti/rest-api";

type GetPGSTokenInput = {
  orderEntityId: string;
  isFreeTrial: boolean;
  isSubscription: boolean;
};

export const getPGSToken = createAsyncThunk<string, GetPGSTokenInput, { rejectValue: OrderException }>(
  "checkout/getPGSToken",
  async ({ orderEntityId, isFreeTrial, isSubscription }: GetPGSTokenInput, { rejectWithValue }) => {
    const pgsApi = PgsApi.init();
    const { uuid = "" } = getUser();

    try {
      const paymentToken = await pgsApi.placeOrder({
        orderId: orderEntityId,
        customer: {
          uuid,
        },
        tokenize_payment: isFreeTrial || isSubscription,
      });

      if (!paymentToken) {
        const error = new Error("Payment token is empty");
        newrelic.noticeError(error, {
          orderEntityId,
          uuid,
          isFreeTrial: Number(isFreeTrial),
        });

        throw error;
      }

      setPaymentTokenToStorage(paymentToken);
      return paymentToken;
    } catch {
      return rejectWithValue({
        code: OrderExceptionCode.PGSIssue,
      });
    }
  }
);
